module.exports = __webpack_public_path__ + "static/img/LlnkedinSquare.78f6b269.svg";